const CompanyAdmin = () => {
  return (
    <div className="page-title">
      <h1>Company Administrators</h1>
    </div>
  );
};

export default CompanyAdmin;
